import React from 'react'
import { Modal, Button, ModalInjectedProps } from '@sketch/components'
import { useGetIntegrationIdentityConnectUrl } from '../../hooks'
import { GetIntegrationIdentityConnectUrlMutationVariables } from '@sketch/gql-types'

interface ConnectIntegrationIdentityModalProps extends ModalInjectedProps {
  integrationName: string
  integrationProvider: GetIntegrationIdentityConnectUrlMutationVariables['provider']
  workspaceId: GetIntegrationIdentityConnectUrlMutationVariables['workspaceIdentifier']
}

export const ConnectIntegrationIdentityModal: React.FC<
  ConnectIntegrationIdentityModalProps
> = ({ hideModal, integrationName, integrationProvider, workspaceId }) => {
  const { getIntegrationIdentityConnectUrl, loading } =
    useGetIntegrationIdentityConnectUrl()

  const handleContinue = () => {
    getIntegrationIdentityConnectUrl({
      variables: {
        provider: integrationProvider,
        workspaceIdentifier: workspaceId,
      },
    })
  }

  return (
    <Modal title="You’re leaving sketch.com" onCancel={hideModal}>
      <Modal.Body>
        <p>
          {'We’ll redirect you to '}
          {integrationName}
          {'’s website to link your personal account with Sketch.'}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={hideModal}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleContinue} loading={loading}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
